import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const PreshiftPopupStyle = makeStyles({
  PreshiftPopupWrapper: {
    "& .inner-wrapper": {
      display: "flex",
      flexWrap: "wrap",
      paddingTop: 5,
      justifyContent: "flex-end",
      "& .search-wrapper": {
        maxWidth: "360px",
        flex: "0 0 360px",
        marginTop: 15,
        "@media(max-width:991px)": {
          maxWidth: "100%",
          flex: "0 0 100%",
        },
        "& .MuiOutlinedInput-inputAdornedEnd": {
          paddingRight: "40px !important",
        },
        "& .MuiOutlinedInput-adornedEnd": {
          padding: "0",
          position: "relative",
          "& img": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "15px",
          },
        },
      },
      "& .btn-group": {
        display: "flex",
        marginTop: 15,
        "@media (max-width: 574px)": {
          display: "block",
          width: "100%",
          marginTop: 0,
        }
      },
      "& .btn-wrapper": {
        marginLeft: 15,
        "@media (max-width: 574px)": {
          marginLeft: 0,
          marginTop: 15,
        },
        "& .primary-btn": {
          minHeight: 50,
          fontSize: 16,
          minWidth: 160,
          fontWeight: 600,
          textTransform: "uppercase",
          "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
            boxShadow: "none !important",
          },
          "@media (max-width: 574px)": {
            minWidth: "100%",
          }
        },
      },
    }
  },
  customModal: {
    "& .close-modal": {
      position: "absolute",
      top: 15,
      right: 20,
      "& img": {
        cursor: "pointer",
      },
    },
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "40px",
      textAlign: "center",
      maxWidth: 1400,
      "&.MuiDialog-paperScrollBody": {
        "@media (max-width: 991px)": {
          display: "block",
        },
      },
      "@media(max-width:767px)": {
        width: "auto",
        maxWidth: "100%",
        padding: "25px 15px",
        margin: 15,
      },
      "& .MuiDialogContent-root,& .MuiDialogActions-root, & .MuiDialogTitle-root": {
        padding: "0",
        justifyContent: "center",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 0,
        "& .MuiTypography-root": {
          fontWeight: 700,
          fontSize: "24px",
          lineHeight: "1.321",
          color: colors.black,
          "& img": {
            display: "block",
            margin: "0 auto 20px",
          },
        },
      },
    },
  }
});

export { PreshiftPopupStyle };
